<template>
  <layout>
    <div slot="content">
      <i-card title="添加搜一搜配置" contentWidth="80%">
        <div slot="content">
          <el-form :model="fields" label-width="120px" size="small">
            <el-form-item label="产品类型" prop="pid">
              <el-radio-group v-model="productType" size="medium" @change="getProductList">
                <el-radio-button :label="10">线路</el-radio-button>
                <el-radio-button :label="11">船票</el-radio-button>
                <el-radio-button :label="12">景区</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="选择产品" prop="pid">
              <el-select v-model="fields.pid" :filterable="true" placeholder="请选择" style="width: 100%">
                <el-option
                  v-for="item in productList"
                  :key="'index'+item.id"
                  :label="item.title"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="小程序链接" prop="jump_url">
              <el-input v-model="fields.jump_url"></el-input>
            </el-form-item>
            <el-form-item label="更多跳转链接" prop="jump_more">
              <el-input v-model="fields.jump_more"></el-input>
            </el-form-item>
            <el-form-item label="所在省" prop="province">
              <el-input v-model="fields.province"></el-input>
            </el-form-item>
            <el-form-item label="所在市" prop="city">
              <el-input v-model="fields.city"></el-input>
            </el-form-item>
            <el-form-item label="所在区县" prop="district">
              <el-input v-model="fields.district"></el-input>
            </el-form-item>
            <el-form-item label="景区地址" prop="scenic_address">
              <el-input v-model="fields.scenic_address"></el-input>
            </el-form-item>
            <el-form-item label="评分" prop="scenic_score">
              <el-input v-model="fields.scenic_score"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :loading="loading" @click="addConfig">立即提交</el-button>
              <router-link :to="{name:'settings.soso.config_list'}">
                <el-button>返回列表</el-button>
              </router-link>
            </el-form-item>
          </el-form>
        </div>
      </i-card>
    </div>
  </layout>
</template>

<script>
export default {
  name: "sailings",
  data: function () {
    return {
      loading: false,
      productType: 10,
      productList: [],
      configId: "",
      postUrl: "addSosoConfigLList",
      fields: {
        pid: '',
        jump_url: '',
        province: '',
        city: '',
        district: '',
        scenic_address: '',
        scenic_score: '',
        jump_more: '',
      },
    }
  },
  methods: {
    getProductList: function () {
      this.fields.pid = '';
      this.$http.request('onlineProductList', {type: this.productType}).then(res => {
        this.productList = res.data;
      });
    },
    addConfig: function () {
      this.loading = true;
      this.postUrl = this.configId ? 'editSosoConfigLList' : 'addSosoConfigLList';
      this.$http.request(this.postUrl, this.fields).then(res => {
        this.loading = false;
        if (res.status === 'success') {
          this.$message({
            message: res.message, type: 'success', onClose: () => {
              this.$router.back();
            }
          });
        }
      }).catch(res => {
        this.loading = false;
      });
    },
    getConfig: function () {
      if (!this.configId) {
        return;
      }
      this.$http.request('getSosoConfigLList', {id: this.configId}).then(res => {
        if (res.status === 'success') {
          this.productType = res.data.type;
          this.getProductList();
          this.fields = res.data;
        }
      })
    }
  },
  created: function () {
    this.configId = this.$route.query.id || "";
    this.getConfig();
    this.getProductList();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/settings/soso/add_config.vue